module.exports = __webpack_public_path__ + "img/resultado.a4ec6099.svg";